import { render, staticRenderFns } from "./share-widget.vue?vue&type=template&id=04e3ec3a&"
import script from "./share-widget.vue?vue&type=script&lang=js&"
export * from "./share-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e3ec3a')) {
      api.createRecord('04e3ec3a', component.options)
    } else {
      api.reload('04e3ec3a', component.options)
    }
    module.hot.accept("./share-widget.vue?vue&type=template&id=04e3ec3a&", function () {
      api.rerender('04e3ec3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/base/share-widget.vue"
export default component.exports